import React from "react";
import { ListItem } from "@tremor/react";
import { Link } from "react-router-dom";
import { truncateCourt } from "../../../utils/truncateCourt";

const DikasimosListItem = ({ singleCase }) => {
  const ellipsisStyle = {
    display: "block",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  };

  const trimText = (value, maxChars) => {
    if (!value) return "";
    return value.length > maxChars
      ? `${value.slice(0, maxChars).trimEnd()}...`
      : value;
  };

  return (
    <ListItem className="grid grid-cols-[minmax(0,1fr)_110px] items-start gap-3">
      <div className="min-w-0">
        <Link to={`/cases/${singleCase.id}`} className="block min-w-0 w-full no-underline hover:no-underline">
          <p className="text-tremor-default font-bold">
            {singleCase.gak}/{singleCase.year}
          </p>
          <p
            className="text-tremor-default"
            style={ellipsisStyle}
            title={truncateCourt(singleCase.court)}
          >
            {truncateCourt(singleCase.court)}
          </p>
        </Link>
        {singleCase.note && (
          <p
            className="text-tremor-default text-slate-500"
            style={ellipsisStyle}
            title={singleCase.note}
          >
            {trimText(singleCase.note, 58)}
          </p>
        )}
      </div>
      <div className="w-[110px] shrink-0 pl-2">
        <p className="text-right text-tremor-default font-bold">{singleCase.date}</p>
      </div>
    </ListItem>
  );
};

export default DikasimosListItem;
